import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
    const navigate = useNavigate();
    return (
        <Box
            sx={{
                width: '100vw',
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                gap: '16px',
            }}
        >
            <Typography variant="h1" color="primary">
                404 Not Found
            </Typography>
            <Button onClick={() => navigate('/')} variant="outlined" color="primary">
                Go Home
            </Button>
        </Box>
    );
}
